<template>
  <el-dialog
    :title="title"
    :visible.sync="showModal"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    width="880px"
  >
    <el-form ref="form" :model="form" label-width="83px">
      <el-form-item
        label="问卷标题:"
        :rules="[
          { required: true, message: '请输入问卷标题', trigger: 'blur' },
        ]"
        prop="title"
      >
        <el-input v-model="form.title" style="width: 450px;"></el-input>
      </el-form-item>
      <div
        v-for="(item, templateIdx) in form.template"
        :key="templateIdx"
        class="question-item"
      >
        <div class="question-self">
          <el-form-item
            label="题目类型"
            :rules="[
              { required: true, message: '请选择题目类型', trigger: 'blur' },
            ]"
            :prop="'template' + '[' + templateIdx + ']' + '.type'"
          >
            <el-select
              v-model="item.type"
              placeholder="请选择类型"
              @change="onChangeQuestionType(templateIdx)"
              :disabled="type === 'edit' || type === 'copy'"
            >
              <el-option
                v-for="item in topicType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="题目标题"
            :rules="[
              { required: true, message: '请输入题目标题', trigger: 'blur' },
            ]"
            :prop="'template' + '[' + templateIdx + ']' + '.name'"
          >
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入题目标题"
              v-model="item.name"
              style="width: 450px;"
            />
          </el-form-item>
          <el-form-item
            v-if="item.type === 1 || item.type === 2"
            v-for="(_, optionsIdx) in item.option"
            :key="optionsIdx"
            :label="optionsIdx === 0 ? '选项' : ''"
            :rules="[
              { required: true, message: '请输入选项内容', trigger: 'blur' },
              { validator: validateSame, trigger: 'blur' },
            ]"
            :prop="
              'template[' + templateIdx + '].option' + '[' + optionsIdx + ']'
            "
          >
            <div class="option-control">
              <el-input
                placeholder="选项内容"
                v-model="item.option[optionsIdx]"
                @blur="selectBlur(templateIdx)"
                style="width: 450px;"
              />
              <el-row style="margin-left: 10px;" type="flex">
                <el-button
                  icon="el-icon-top"
                  size="small"
                  circle
                  :disabled="optionsIdx === 0"
                  @click="moveUp(item.option, optionsIdx)"
                ></el-button>
                <el-button
                  icon="el-icon-bottom"
                  size="small"
                  circle
                  :disabled="item.option.length === optionsIdx + 1"
                  @click="moveDown(item.option, optionsIdx)"
                ></el-button>

                <el-button
                  icon="el-icon-minus"
                  type="danger"
                  size="small"
                  circle
                  @click="removeField(item.option, optionsIdx)"
                  v-if="item.option.length > 1"
                ></el-button>
                <el-button
                  icon="el-icon-plus"
                  type="primary"
                  size="small"
                  circle
                  @click="addField(item.option)"
                  v-if="item.option.length === optionsIdx + 1"
                ></el-button>
              </el-row>
            </div>
          </el-form-item>
        </div>

        <div class="question-side">
          <p class="question-index">
            {{ templateIdx < 10 ? `0${templateIdx + 1}` : templateIdx + 1 }}
          </p>
          <div class="question-control" v-if="type === 'add'">
            <button
              class="add"
              @click.prevent="questionAdd(form.template, templateIdx + 1)"
            >
              <i class="el-icon-plus"></i>
            </button>
            <button
              class="remove"
              @click.prevent="questionRemove(form.template, templateIdx)"
            >
              <i class="el-icon-minus"></i>
            </button>
            <button
              class="up"
              @click.prevent="questionUp(form.template, templateIdx)"
            >
              <i class="el-icon-top"></i>
            </button>
            <button
              class="down"
              @click.prevent="questionDown(form.template, templateIdx)"
            >
              <i class="el-icon-bottom"></i>
            </button>
          </div>
        </div>
      </div>
      <el-form-item>
        <el-button @click="trunOff">取消</el-button>
        <el-button
          type="primary"
          :loading="submitting"
          @click="onSubmit('form')"
          >确认</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { questionnaire } from '@/api/basic'

export default {
  data() {
    return {
      validateSame: (rule, value, callback) => {
        console.log(this.form.template[this.selectIndex])
        if (this.form.template[this.selectIndex]?.option.length > 1) {
          if (
            this.form.template[this.selectIndex].option.filter(
              (item) => value == item
            ).length > 1
          ) {
            callback(new Error('选项重复'))
          } else {
            callback()
          }
        } else {
          callback()
        }
      },
      topicType: [
        {
          value: 3,
          label: '问答题',
        },
        {
          value: 1,
          label: '单选',
        },
        {
          value: 2,
          label: '多选',
        },
        {
          value: 4,
          label: '上传附件',
        },
      ],
      form: {
        id: null,
        title: '',
        template: [{ name: '', type: null, option: [''] }],
      },
      selectIndex: null, // 保存题目数组索引（拿到是哪题）
      questionOldType: null,
      submitting: false,
    }
  },
  props: {
    // 展示
    show: {
      default: false,
      type: Boolean,
    },
    // 模式
    type: {
      default: 'add',
      type: String,
    },
    // 编辑的数据
    editData: null | Object,
  },
  methods: {
    selectBlur(index) {
      this.selectIndex = Number(index)
    },
    trunOff() {
      this.showModal = false
    },
    handleUpdateFormModelByModalType() {
      const handlers = {
        add: () => {
          this.form = {
            id: null,
            title: '',
            template: [{ name: '', type: null, option: [''] }],
          }
        },
        edit: () => {
          const { id, title, template } = this.editData
          this.form = {
            id,
            title,
            template,
          }
        },
        copy: () => {
          const { title, template } = this.editData
          this.form = {
            title,
            template,
          }
        },
      }

      handlers[this.type]()
    },
    // 问题选项操作
    onChangeQuestionType(idx) {
      this.questionOldType = this.form.template[idx].type

      if (this.form.template[idx].type === 4) {
        // this.form.template[idx].name = "请上传附件"
        this.form.template[idx].name = ''
      } else {
        this.form.template[idx].name = ''
      }

      // if (this.questionOldType === 4) {
      //     this.form.template[idx].name = ''
      // }
    },
    moveUp(options, index) {
      const item = options.splice(index, 1)
      options.splice(index - 1, 0, item[0])
    },
    moveDown(options, index) {
      const item = options.splice(index, 1)
      options.splice(index + 1, 0, item[0])
    },
    removeField(options, index) {
      options.splice(index, 1)
    },
    addField(options) {
      options.push('')
    },
    // 问题操作
    questionAdd(arr, index) {
      arr.splice(index, 0, {
        name: '',
        type: null,
        option: [''],
      })
    },
    questionRemove(arr, index) {
      if (arr.length === 1) {
        return this.$message.error('题目至少有一个!')
      }
      arr.splice(index, 1)
    },
    questionUp(arr, index) {
      // if(arr)
      const item = arr.splice(index, 1)
      arr.splice(index - 1, 0, ...item)
    },
    questionDown(arr, index) {
      const item = arr.splice(index, 1)
      arr.splice(index + 1, 0, ...item)
    },
    onSubmit(formName) {
      let reFlag = false
      this.form.template.forEach((templateItem, templateIndex) => {
        templateItem.option.forEach((item) => {
          if (
            templateItem.option.filter((item2) => item2 === item).length > 1
          ) {
            reFlag = true
            this.selectBlur(templateIndex)
            // this.form.template[templateIndex].option[0]
            this.form.template[templateIndex].option.forEach((item, index) => {
              this.$refs[formName].validateField(
                `template[${index}].option[${index}]`
              )
            })
          }
        })
      })
      if (reFlag) {
        return this.$message({
          message: '有重复选项!',
          type: 'error',
        })
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.submitting = true
            await questionnaire.addUpdate(this.form)
            this.$message({
              message: `已${this.type === 'add' ? '新建' : '编辑'}问卷!`,
              type: 'success',
            })
            this.$emit('onUpdate')
            this.trunOff()
          } catch {
            this.$message.error('出错了!')
          } finally {
            this.submitting = false
          }
        }
      })
    },
  },
  computed: {
    showModal: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
    title() {
      const { type } = this

      const title = {
        add: '新建问卷',
        edit: '编辑问卷',
        copy: '复制问卷',
      }

      return title[type]
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.handleUpdateFormModelByModalType()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.question-item {
  // position: relative;
  display: flex;

  .question-self {
    width: 780px;
    padding-top: 22px;
    border-top: 2px dashed #606266;
    // background-color: gray;

    .question-title {
      height: 40px;
      border: none;
      outline: none;
      color: #606266;
      font-size: inherit;
    }

    .option-control {
      display: flex;
      align-items: center;
    }
  }

  .question-side {
    min-height: 280px;

    &:last-child {
      min-height: auto;
    }

    .question-index {
      margin: -0.6rem 0 10px 50%;
      // margin-bottom: 10px;
      // margin-left: 50%;
      transform: translateX(-50%);
      white-space: nowrap;
      font-size: 1.2rem;
      font-weight: bold;
      color: #606266;
    }

    .question-control {
      display: flex;
      align-items: center;
      flex-direction: column;
      transition: 0.2s;
      opacity: 0;

      button {
        width: 42px;
        height: 42px;
        text-align: center;
        font-size: 21px;
        margin-bottom: 10px;
        color: #606266;
        border: #fff;
        background-color: #fff;
        cursor: pointer;
      }
    }
  }

  &:hover > .question-side .question-control {
    opacity: 1;
  }
}
</style>
